import {GETME_START, GETME_SUCCESS, GETME_FAIL, GETME_RESET} from './constants';
import {GetMeActions, GetMeState} from './types';

const initialState: GetMeState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetMeActions,
): GetMeState => {
  switch (action.type) {
    case GETME_START:
      return {
        ...initialState,
        loading: true,
      };
    case GETME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GETME_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GETME_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
